import { ISurveyEvalResponse } from "src/services";

export const sortByDate = (a: ISurveyEvalResponse, b: ISurveyEvalResponse) => {
  if (a.startDate > b.startDate) {
    return 1;
  } else if (a.startDate < b.startDate) {
    return -1;
  } else {
    return 0;
  }
};



// WEBPACK FOOTER //
// ./src/pages/director/SurveyDataCenter/hooks/utils/sortByDate/sortByDate.ts